<template>
    <div class="wallets">
        <div class="list-container">
            <div>
                <p class="list-title">{{ list.title }}</p>
                <p class="list-count" style="margin: 0px 5px">Count : {{ wallets.length }}</p>
                <p class="btn sm" style="position: absolute;right:5px;width:120px;line-height: 2;" @click="newWallet">new wallet</p>
                <!-- <div class="x" @click="exit()"></div> -->
            </div>
            <div class="list-search" :style="{ 'grid-template-columns': list.grid }" style="margin-top: 20px;">
                <div class="item-search" v-for="field in list.fields" @keyup="search" @change="search">
                    <p :class="['order',field.order || '']" @click="order(field)"></p><p>{{ field.title }}</p>
                    <input v-model="field.value" />
                </div>
            </div>
            <div class="list-items">
                <div v-for="(item,i) in wallets.filter(w => w.show)" :key="i" class="list-item-container" >
                    <div class="list-item" :style="{ 'grid-template-columns': list.grid }" :id="item._id" :key="item._id">
                        <div v-for="(field,i) in list.fields">
                            <p 
                                :class="(field.class || '')+' ellip'" 
                                @click="fieldClick(field,item,$event)" 
                                v-html="( i == 0 && Array.isArray(item.components) && `<span class='order l-${item.components.length}'></span>` || '' ) +( typeof field.map == 'function' ? field.map(item) : ( item[field.field] || '' ) )"
                                ></p>
                        </div>
                    </div>
                    <div v-if="card && item == wallet" style="display: flex;justify-content: space-around;background-color: white;position: relative;">
                        <div class="x" @click="card = false"></div>
                        <Card :card="card" @editCard="editCard(card)" @removeCard="removeCardFromWallet(item,card)" />
                    </div>
                    <component v-for="(component,i) in item.components" :key="i" :is="component" :item="item" @exit="toggleWalletList(item)"></component>
                </div>
            </div>
            <!-- 
            <div class="btns">
                <p class="btn" @click="showCards = !showCards" style="width: 200px;">show all cards</p> 
                <p class="btn" @click="newWallet" style="width: 200px;">new wallet</p>
            </div>
            -->
        <component v-for="(component,index) in components" :key="index" :item="component.item" :is="component.component" @emit="emit" :component="component" @editCard="editCard" @setExpiry="setExpiry" @removeCard="removeCardFromWallet" @addCardToWallet="addCardToWallet"></component>
        <!-- <Cards v-if="showCards" @editCard="editCard" @setExpiry="setExpiry" @newCard="newCard" @removeCard="removeCard" @exit="showCards = false" />-->
        <div v-if="showCards" class="all-cards">
            <WalletList @emit="emit" @exit="showCards = false" :showWallets="true" />
        </div>
        <!-- 
        <div v-if="selectCard" class="fixed-scroller">
            <div class="v-alert select-wallet">
                <header><p>Add Cards to Wallet</p><div class="x" @click="selectCard = false"></div></header>
                <div class="select-list">
                    <div v-for="card in cards" class="select-item" @click="addCardToWallet({ wallet: wallet, card: card })">
                        <p>{{ card.title }}</p>
                    </div>
                </div>
            </div>
        </div>
        -->
        <div v-if="selectCard" class="fixed-scroller">
            <div class="v-alert select-wallet w-600">
                <header><p>Add Cards to Wallet</p><p class="btn" @click="updateCards()" style="position: absolute;top: 0px;width: 120px;color: white;line-height: 1.5;right: 60px;margin: 5px;">save</p><div class="x" @click="selectCard = false"></div></header>
                <div style="display: grid;grid-template-columns: 40px 1fr;">
                    <input type="checkbox" style="margin:6px 10px" @change="showSelectedCards($event)" />
                    <input style="margin: 3px 10px;width: calc(100% - 40px);" @keyup="filterCards($event)" />
                </div>
                <div class="select-list">
                    <div v-for="card in cards.filter(c => c.show)" class="select-item" style="display: grid;grid-template-columns: 40px 1fr;"> 
                        <input type="checkbox" v-model="card.selected" style="margin: 0px;background-color: white;" /><p class="ellip" @click="addCardToWallet({ wallet: wallet ,card: card })">{{ card.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

import { mapMutations, mapActions } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import distanceDate from '@/utils/distanceDate.js'
import WebSoc from '../utils/WebSoc.js';
import Alert from '../utils/Alert.js'
import showWallet from '../components/showWallet.vue';
import editVideoCard from '@/components/editVideoCard.vue'
import Cards from '../components/Cards.vue';
import WalletList from '../components/WalletList.vue'
import makeGrid from '../utils/makeGrid.js';
import localSearch from '../utils/localSearch.js';
import Card from '../components/Card.vue';

export default {
    name: 'wallets',
    components: {
        List,
        showWallet,
        Cards,
        editVideoCard,
        WalletList,
        Card
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        cards () { return this.$store.getters.cards },
        wallets () { return this.$store.getters.wallets }
    },
    data () {
        return {
            showCards: false,
            sendTypes: ['no Message','send SMS','send Email'],
            sendType: 'no Message',
            emaiBanner: '',
            components: [],
            item: false, 
            selectedAll: false,
            smsCustomers: [],
            emailCustomers: [],
            selectWallet: [],
            selectCard: false,
            cardWallet: fetch,
            smsMessage: '',
            progress: false,
            card: false,
            list: { 
                grid: '',
                width: 100,
                fields: [
                    { title: 'Title', class: 'td-ulb', field: 'title', width: 270 },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 140, map: item => format(item.created,'dd/MM/yy') },
                    { title: 'Updated', field: 'update', class: 'ta-r', width: 170, map: item => distanceDate(item.update,'dd/MM/yy') },
                    //{ title: 'Sent', field: 'qtySent', class: 'ta-r', type: 'num', width: 90 },
                    //{ title: 'Opens', field: 'opens', class: 'ta-r', type: 'num', width: 90 },
                    //{ title: 'Unique', field: 'uniqueOpens', class: 'ta-r', width: 90, map: item => Object.keys(item.uniqueOpens || {}).length },
                    { title: 'Cards', field: 'cards', width: '1fr', map: item => '<span class="add"></span>'+item.cards.filter(c => c).filter(c => c.show).map((c,i,arr) => '<span class="td-ulb" id="'+c._id+'">'+c.title+'</span>' + ( i < arr.length - 1 ? '<span>, </span>' : '') ).join('') },
                ],
                project: {},
            }            
        }
    },
    created () {
        this.list.grid = makeGrid(this.list);
    },
    mounted () {
        //this.getWalletsAndCards();
    },
    methods: {
        showSelectedCards ( e ) {
            var checked = e.target.checked;
            this.cards.forEach(card => {
                card.show = checked ? card.selected : true; 
            });
         },
        filterCards ( e ) {
            var value = e.target.value;
            var text = new RegExp(value.split('* '),'i');
            this.cards.forEach(card => {
                card.show = value ? text.test(card.title) : true
            })
        },
        updateCards () {
            var wallet = this.wallet;
            var cards = this.cards.filter(c => c.selected);
            var addCards = cards.filter(c => !wallet.cards.find(card => card._id == c._id));

            var addText = addCards.length > 0 ? '<span style="font-weight:bold;width:100%;line-height:3">Add Cards</span>'+addCards.map(c => '<p>'+c.title+'</p>').join('') : '';
            
            var removeCards = wallet.cards.filter(c => !cards.find(card => card._id == c._id)).filter(c => c); // <span style="font-weight:bold;width:100%;line-height:3">Add Cards</span> // <span style="font-weight:bold;width:100%;line-height:3">Remove Cards</span>
            
            var removeText = removeCards.length > 0 ? '<span style="font-weight:bold;width:100%;line-height:3">Remove Cards</span>'+removeCards.map(c => '<p>'+c.title+'</p>').join('') : '';

            if ( !addText && !removeText ) return Alert.message('No Changes');
            
            Alert.yesno(addText+removeText,yes =>{
                
                if ( !yes ) return;

                this.selectCard = false;
                
                if ( addCards.length > 0 ) {
                    WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { $each: addCards.map(c => { return { _id: c._id }}) } } } },resp => {
                        console.log('resp',resp);
                    }) 
                }
                if ( removeCards.length > 0 ) {
                    WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pullAll: { cards: removeCards.map(c => { return { _id: c._id } }) } } },resp => {
                        console.log('resp',resp);
                    })
                }
            })
        },
        search ( e ) {
            var keyCode = e && e.keyCode;
            if ( [9,16,27,38,40].indexOf(keyCode) > -1 ) return;
            clearTimeout(this._search);
            var items = this.wallets.map(i => i); 
            this._search = setTimeout(() => {
                this.wallets.forEach(wallet => {
                    this.setObjValue({ obj: wallet, k: 'show', v: true })
                });
                this.cards.forEach(card => {
                    this.setObjValue({ obj: card, k: 'show', v: true })
                })
                this.list.fields.forEach(field => {
                        var p = {};
                        if ( field.order ) {
                            switch ( field.type ) {
                                case 'date':
                                    console.log('sort',field.field,field.order == 'asc' ? -1 : 1)
                                    break;
                                default: 
                                console.log('sort',field.field,field.order == 'asc' ? 1 : -1)
                            }
                            
                        }
                        if ( field.value.length == 0 ) return;

                        if ( field.type == 'num' ) {

                            var val = field.value;
                            var $lt = val.split('<')[1] && parseFloat(val.split('<')[1].split('>')[0]);
                            var $gt = val.split('>')[1] && parseFloat(val.split('>')[1].split('<')[0]);
                            if ( !isNaN($lt) ) { p[field.field] = { $lt: $lt } }
                            if ( !isNaN($gt) ) { p[field.field] = p[field.field] || {}; p[field.field].$gt = $gt; }
                            if ( !p[field.field]   ) { p[field.field] = { $eq: parseInt(val) } }

                        } else {

                            p[field.field] = { $regex: field.value, $options: 'i' }
                        }
                        if ( p[field.field].$regex ) {
                            var text = new RegExp(p[field.field].$regex.split('').join(' *'),'i')

                            switch ( field.field ) {
                                case 'cards':
                                this.wallets.forEach(wallet => {
                                    var showWallet = wallet.cards.reduce((p,card) => {
                                        var showCard = text.test(card.title);
                                        this.setObjValue({ obj: card, k: 'show', v: showCard });
                                        return p || showCard;
                                    },false);
                                    this.setObjValue({ obj: wallet, k: 'show', v: showWallet });
                                });
                                break;
                                default:
                                this.wallets.forEach((wallet) => {
                                    this.setObjValue({ obj: wallet, k: 'show', v: text.test(wallet[field.field]) })
                                })
                            }

                        }
                    
                        if ( p[field.field].$gt ) {

                        }

                        if ( p[field.field].$lt ) {

                        }

                        if ( p[field.field].$eq ) {

                        }
                        
                        return console.log('filter',JSON.stringify(p,null,1));                
                })     
            },200);      
        },
        order ( field ) {
            console.log('order',field);
        },
        toggleWalletList ( item ) {
            var v = [];
            if ( item.components.length == 0 ) v.push('WalletList');
            this.setObjValue({ obj: item, k: 'components', v })
        },
        fieldClick ( field, item, e ) {
            switch ( field.field ) {
                case 'title':
                    return this.toggleWalletList(item);
                case 'cards':
                    if ( e.target.classList.contains('add') ) {
                        this.wallet = item;
                        this.selectCard = true;
                        var wallet = item;
                        this.cards.forEach(card => {
                            this.setObjValue({ obj: card, k: 'show', v: true });
                            this.setObjValue({ obj: card, k: 'selected', v: !!wallet.cards.find(c => c._id == card._id ) });
                        });
                        return console.log('addCard to wallet',item);
                    }

                    var card = this.cards.find(c => c._id == e.target.id);
                    var wallet = item;
                    return this.removeCardFromWallet(wallet,card);

                    this.card = card == this.card ? false : card;
                    if ( this.card ) {
                        this.wallet = item;
                    } else {
                        this.wallet = false;
                    }
                    return;
            }
            console.log('fieldClick',{ field, item });
            console.log('e.target',e.target);
        },
        editCard ( card ) {
            return this.components.push({ t: 'edit-card', component: 'editVideoCard', item: card });            
        },
        newCard () {
            this.components.push({ t: 'edit-card', component: 'editVideoCard', item: false });        
        },
        setExpiry ( card ) {
            console.log('Wallets setExpiry card',card)
        },
        removeCard ( card ) {
            Alert.yesno('Delete '+card.title+' ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('update',{ DB: 'cards', _id: card._id, update: { $set: { removed: true } }});
            })
        },
        removeCardFromWallet ( wallet, card ) {
            Alert.yesno('Remove<br>'+card.title+'<br>from<br>'+wallet.title+'?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: { _id: card._id } }}},() => {
                    this.card = false;
                    this.$forceUpdate();
                })
            })
        },
        addCardToWallet ({ card, wallet } ) {
            var current = wallet.cards.find(c => c._id == card._id);
            if ( current ) return Alert.message(card.title+'<br>is already in<br>'+wallet.title);
            this.selectCard = false;
        
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { _id: card._id }}}},() => {
                this.wallet = false;
                console.log('added');
                forceUpdate();
            })

            const forceUpdate = () => {
                this.$forceUpdate();
                setTimeout(() => {
                    this.$forceUpdate()
                },2000)
                setTimeout(() => {
                    this.$forceUpdate()
                },5000)                
            }
        },
        newWallet () {
            Alert.prompt('New Wallet Name',title => {
                if ( !title ) return;

                var wallet = {
                    client_id: this.client_id,
                    title,
                    qtySent: 0,
                    opens: 0,
                    uniqueOpens: {},
                    cards: []
                };

                WebSoc.SEND('newWallet',{ wallet },resp => {
                    console.log('wallet added resp',resp);
                })
            });
        },
        'wallets-list' ( data ) {
            console.log('data.action',data.action);
            switch ( data.action ) {
                case 'new':
                    return this.newWallet();
            }
            if ( !data.field ) return console.log('!data.field wallets-list data',data);
            switch ( data.field.field ) {
                case 'title':
                    if ( data.e.target.classList.contains('order') ) { 
                        var components = data.item.components;
                        if ( components.length > 0 ) return components.pop();
                        return components.push('WalletList')
                    }
                    return this.components.push({ t: 'show-wallet', component: 'showWallet', item: data.item });
            }
            console.log('wallet-list data ??',data);
        },
        'show-wallet' ( data ) {
            switch ( data.action ) {
                case 'exit':
                    return this.components = this.components.filter(c => c != data.component);
            }
            console.log('show-wallet what with',data);
        },
        'edit-card' ( data ) {
            switch ( data.action ) {
                case 'exit':
                    return this.components = this.components.filter(c => c.t != data.t);
            }
        },
        'component' ( data ) {
            switch ( data.action ) {
                case 'exit':
                    return data.item.components.pop();
            }
        },
        emit ( data ) {
            console.log('emit data',data);
            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('emit data ??',data);

        },
        ...mapActions([
            'getDB',
            'getWalletsAndCards'
        ]),
        ...mapMutations([
            'setObjValue'
        ])
    }
}

</script>

<style lang="scss">
span.add {
    width: 18px;
    height: 25px;
    position: relative;
    float: left;
    &:before,&:after {
        content: '';
        width: 15px;
        height: 3px;
        top: 11px;
        position: absolute;
        background-color: green;
    }
    &:after {
        transform: rotate(90deg);
    }
}    
.wallets .all-cards {
    position: fixed;
    background-color: white;
    left: 0px;
    top: 50px;
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: scroll;;
}
</style>